import { render, staticRenderFns } from "./404-error.vue?vue&type=template&id=5225cd3a"
import script from "./404-error.vue?vue&type=script&lang=js"
export * from "./404-error.vue?vue&type=script&lang=js"
import style0 from "./404-error.vue?vue&type=style&index=0&id=5225cd3a&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderContactPage: require('/home/apprentissage-montpellier/www/prod/AM-frontend/components/HeaderContactPage.vue').default})
